import React from 'react';

export class DroppableCellRenderer extends React.PureComponent {
  handleDragOver = (e) => e.preventDefault();

  handleDrop = (e) => {
    e.preventDefault();
    const userAgent = window.navigator.userAgent;
    const isIE = userAgent.indexOf('Trident/') >= 0;
    const jsonData = e.dataTransfer.getData(isIE ? 'text' : 'application/json');
    const draggedItems = JSON.parse(jsonData);

    // if data missing, do nothing
    if (!Array.isArray(draggedItems) || !draggedItems.length) {
      return;
    }

    // only allow drop on a group
    if (!this.props.data.group) {
      return;
    }

    draggedItems.forEach((draggedItem) => {
      if (draggedItem.groupId !== this.props.data.id) {
        this.props.onDrop(draggedItem.id, this.props.data.id);
      }
    });
  };

  render() {
    return (
      <div
        className="droppable-cell"
        onDragOver={this.handleDragOver}
        onDrop={this.handleDrop}
      >
        {this.props.children || this.props.valueFormatted || this.props.value}
      </div>
    );
  }
}
